const ComboInterface = {
    getId() {
        return this.id;
    },
    getCombo() {
        return this.combo;
    },
    getExpMax() {
        return this.expMax;
    },
};

export default ComboInterface;
